<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-briefcase"></i>
        {{ $t('project.title') }}
        <createButton name="projects_company_create" :title="$t('project.company.create.title')"></createButton>
        <createButton name="projects_property_create" :title="$t('project.property.create.title')"></createButton>
      </div>
      <div class="card-body">
        <errorMessage v-bind:message="error"></errorMessage>

        <div class="table-responsive">
          <table
            class="table table-bordered table-striped"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th>{{ $t('project.form.name') }}</th>
                <th class="drop-down-filter">{{ $t('project.form.type') }}</th>
                <th class="drop-down-filter">{{ $t('project.processStatus') }}</th>
                <th class="drop-down-filter">{{ $t('project.form.companyStatus') }}</th>
                <th class="drop-down-filter">{{ $t('project.company.form.sectorOfActivity') }}</th>
                <th class="drop-down-filter">{{ $t('address.form.region') }}</th>

                <th class="export">{{ $t('project.form.constitutionDate') }}</th>
                <th class="export">{{ $t('project.form.description') }}</th>
                <th class="export">{{ $t('project.form.phone') }}</th>
                <th class="export">{{ $t('project.form.fax') }}</th>

                <th class="export">{{ $t('address.title') }}</th>

                <th class="no-sort no-filter">&nbsp;</th>
                <th class="no-sort no-filter">&nbsp;</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th>{{ $t('project.form.name') }}</th>
                <th class="drop-down-filter">{{ $t('project.form.type') }}</th>
                <th class="drop-down-filter">{{ $t('project.processStatus') }}</th>
                <th class="drop-down-filter">{{ $t('project.form.companyStatus') }}</th>
                <th class="drop-down-filter">{{ $t('project.company.form.sectorOfActivity') }}</th>
                <th class="drop-down-filter">{{ $t('address.form.region') }}</th>

                <th class="export">{{ $t('project.form.constitutionDate') }}</th>
                <th class="export">{{ $t('project.form.description') }}</th>
                <th class="export">{{ $t('project.form.phone') }}</th>
                <th class="export">{{ $t('project.form.fax') }}</th>

                <th class="export">{{ $t('address.title') }}</th>

                <th class="no-sort no-filter">&nbsp;</th>
                <th class="no-sort no-filter">&nbsp;</th>
              </tr>
            </tfoot>
            <tbody>
              <tr
                v-for="project in entites"
                v-bind:data-id="project.id"
                :key="project.id"
                @click="view(project)"
                class="clickable-row"
              >
                <td>
                  {{project.entreprise.name }}
                  <span
                    class="imported_alert"
                    v-if="project.importedFromInvestment"
                  >**</span>
                </td>
                <td
                  class="drop-down-filter"
                >{{project.aLaCarte ? $t('project.company.form.aLaCarte') : project.projectTypeText }}</td>
                <td class="drop-down-filter">{{project.processStatusText}}</td>
                <td class="drop-down-filter">
                  <div v-if="project.companyStatus == 1">
                    <span :class="'companyStatus companyStatus_' + project.companyStatus"></span>
                    {{project.companyStatusText != "0" ? project.companyStatusText : "" }}
                  </div>
                  <div v-if="project.companyStatus == 0">
                    <span :class="'companyStatus exitReason_' + project.reasonInactif"></span>
                    {{project.reasonInactifText != "0" ? project.reasonInactifText : "" }}
                  </div>
                </td>
                <td class="drop-down-filter">{{ project.sectorOfActivityText }}</td>
                <td class="drop-down-filter">{{ project.entreprise.address.regionText }}</td>

                <td>{{ project.constitutionDate | formatDate }}</td>
                <td>{{ project.description }}</td>
                <td>{{ project.entreprise.phone }}</td>
                <td>{{ project.entreprise.fax }}</td>

                <td>{{ project.entreprise.address | addressFormat }}</td>

                <td class="no-sort" align="center">
                  <a
                    href="#"
                    v-if="canReallyCreate(project)"
                    v-bind:title="$t('form.edit_button')"
                    v-on:click.stop="edit(project)"
                  >
                    <span class="fa fa-lg fa-pencil"></span>
                  </a>
                  <a href="#" v-else v-bind:title="$t('form.edit_button')">
                    <span class="fa fa-lg fa-pencil text-muted"></span>
                  </a>
                  &nbsp;
                  <a
                    href="#"
                    v-if="canReallyCreate(project)"
                    v-bind:title="$t('form.copy_button')"
                    v-on:click.stop="copy(project)"
                  >
                    <span class="fa fa-lg fa-copy"></span>
                  </a>
                  <a href="#" v-else v-bind:title="$t('form.copy_button')">
                    <span class="fa fa-lg fa-copy text-muted"></span>
                  </a>
                  &nbsp;
                  <a
                    class="text-info"
                    v-if="canSeeInvestment"
                    v-bind:title="$t('project.investment.view.title')"
                    href="#"
                    v-on:click.stop="showInvestments(project)"
                  >
                    <span class="fa fa-lg fa-money"></span>
                  </a>
                  <a href="#" v-else v-bind:title="$t('project.investment.view.title')">
                    <span class="fa fa-lg fa-money text-muted"></span>
                  </a>
                  &nbsp;
                  <a
                    class="text-info"
                    v-if="canSeeExit"
                    v-bind:title="$t('menu.exits')"
                    href="#"
                    v-on:click.stop="showExits(project)"
                  >
                    <span class="fa fa-lg fa-sign-out"></span>
                  </a>
                  <a href="#" v-else v-bind:title="$t('menu.exits')">
                    <span class="fa fa-lg fa-sign-out text-muted"></span>
                  </a>
                  &nbsp;
                  <a
                    class="text-danger"
                    v-if="canReallyDelete(project)"
                    v-bind:title="$t('form.delete_button')"
                    href="#"
                    v-on:click.stop="deleteEntity(project.id)"
                  >
                    <span class="fa fa-lg fa-trash"></span>
                  </a>
                  <a href="#" v-else v-bind:title="$t('form.delete_button')">
                    <span class="fa fa-lg fa-trash text-muted"></span>
                  </a>
                </td>
                <td>
                  <button
                    class="btn btn-warning mt-2"
                    v-if="!project.focused"
                    v-on:click.stop="focusInIntranet(project)"
                  >{{ $t('member.form.action.focusInIntranet') }}</button>
                  <button
                    v-if="project.focused"
                    v-on:click.stop="focusInIntranet(project)"
                    class="btn btn-danger mt-2"
                  >{{ $t('member.form.action.removeFocusInIntranet') }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <projectStatusLegend></projectStatusLegend>
  </div>
</template>

<script>
import {ProjectServiceClient} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'
import ProjectStatusLegend from './ProjectStatusLegend'
import permission from '../../shared/permission'

export default {
  name: 'Projects',
  mixins: [SearchMixin],
  data() {
    return {
      serviceClient: ProjectServiceClient,
    }
  },
  computed: {
    canSeeInvestment: function() {
      return permission.checkPermission(['Pages.Investments.View'])
    },
    canSeeExit: function() {
      return permission.checkPermission(['Pages.Exits.View'])
    },
  },
  methods: {
    canReallyCreate: function(project) {
      var validatePermission = 'Pages.Projects.Property.Create'
      if (project.projectType == 1) validatePermission = 'Pages.Projects.Company.Create'

      return permission.checkPermission([validatePermission])
    },
    canReallyDelete: function(project) {
      var validatePermission = 'Pages.Projects.Property.Delete'
      if (project.projectType == 1) validatePermission = 'Pages.Projects.Company.Delete'

      return permission.checkPermission([validatePermission])
    },
    view: function(project) {
      this.redirectTo(project, 'view')
    },
    edit: function(project) {
      this.redirectTo(project, 'edit')
    },
    copy: function(project) {
      this.redirectTo(project, 'copy')
    },
    showInvestments: function(project) {
      var route = project.projectType != 1 ? 'property' : 'company'
      this.$router.push({
        name: 'investments_' + route,
        params: {project_id: project.id},
      })
    },
    showExits: function(project) {
      this.$router.push({
        name: 'exits_projects',
        params: {project_id: project.id},
      })
    },
    redirectTo: function(project, mode) {
      var route = project.projectType != 1 ? 'property' : 'company'
      this.$router.push({
        name: 'projects_' + route + '_' + mode,
        params: {id: project.id},
      })
    },
    focusInIntranet: function(project) {
      let projectService = ServiceFactory.create(ProjectServiceClient)
      project.focused = !project.focused
      projectService
        .toggleFocused(project)
        .then(res => {
          console.log('toggle focused success')
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
  components: {
    ProjectStatusLegend,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.dataTables_wrapper {
  padding: 0px;
}
</style>




// WEBPACK FOOTER //
// src/components/projects/Projects.vue